const sv = {
  "Simone Trollmo": "Simone Trollmo",
  Hem: "Hem",
  "Byt språk": "Byt språk",
  "Byt tema": "Byt tema",
  Kontakt: "Kontakt",
  Meny: "Meny",
  Undervisning: "Undervisning",
  "Terminer & priser": "Terminer & priser",
  Övning: "Övning",
  "Boka & kontakt": "Boka & kontakt",
  "Fiol & Celloundervisning": "Fiol & Celloundervisning",
  "Stockholm Stråkstudio": "Stockholm Stråkstudio",
  "Logga in med": "Logga in med",
  Suzukifiol: "Suzukifiol",
  "genom Bromma Hässelby Suzukiförening":
    "genom Bromma Hässelby Suzukiförening",
  Fiollektioner: "Fiollektioner",
  Admin: "Admin",
  Meddelanden: "Meddelanden",
  Innehållshantering: "Sidor",
  Anmälningar: "Anmälningar",
  "Fiol barn": "Fiol barn",
  "Fiol för barn": "Fiollektioner",
  "VT 2026": "VT 2026",
  "Sommarkurs 2026": "Sommarkurs 2026",
  Celloundervisning: "Celloundervisning",
  Övningstips: "Övningstips",
  Övningsvideor: "Övningsvideor",
  Videohantering: "Videohantering",
  "Sök videor...": "Sök videor...",
  "Inga videor hittades": "Inga videor hittades",
  "Laddar fler videor...": "Laddar fler videor...",
  "Visar {count} av {total} videor": "Visar {count} av {total} videor",
  Anmälan: "Anmälan",
  Analys: "Analys",
  Ansökningar: "Ansökningar",
  Ansökningsdatum: "Ansökningsdatum",
  "Ny anmälan från": "Ny anmälan från",
  "Förälderns namn: ": "Förälderns namn: ",
  "Barnets namn": "Barnets namn",
  "Förälderns namn": "Förälderns namn",
  "Barnets namn (för- och efternamn)": "Barnets namn (för- och efternamn)",
  "Barnets personnummer": "Barnets personnummer",
  "Förälderns namn (för- och efternamn)":
    "Förälderns namn (för- och efternamn)",
  "Förälderns personnummer": "Förälderns personnummer",
  Email: "Email",
  Telefonnr: "Telefonnr",
  "Postadress och ort": "Postadress och ort",
  Lektionstyp: "Lektionstyp",
  Suzukiundervisning: "Suzukiundervisning",
  "Mer om Suzukiundervisning finns här": "Mer om Suzukiundervisning finns här",
  "Traditionell undervisning": "Traditionell undervisning",
  Lektionslängd: "Lektionslängd",
  "20min": "20min",
  "30min": "30min",
  "45min": "45min",
  "60min": "60min",
  "20 minuter": "20 minuter",
  "30 minuter": "30 minuter",
  "45 minuter": "45 minuter",
  "60 minuter": "60 minuter",
  "Tack för din anmälan!": "Tack för din anmälan!",
  "Något gick fel... Kontrollera alla fält och försök igen.":
    "Något gick fel... Kontrollera alla fält och försök igen.",
  "Jag godkänner villkoren enligt nedan":
    "Jag godkänner villkoren enligt nedan",
  "Jag har läst information om priser": "Jag har läst information om priser",
  "Du måste ange personnummer": "Du måste ange personnummer",
  "Personnummer måste vara minst 12 siffror":
    "Personnummer måste vara minst 12 siffror",
  "Personnummer får vara max 12 siffror":
    "Personnummer får vara max 12 siffror",
  "Du måste ange adress": "Du måste ange adress",
  "Adressen måste vara minst 15 bokstäver och siffror":
    "Adressen måste vara minst 15 bokstäver och siffror",
  "Du måste välja lektionstyp": "Du måste välja lektionstyp",
  "Du måste välja lektionslängd": "Du måste välja lektionslängd",
  "Du måste acceptera villkoren": "Du måste acceptera villkoren",
  "Du måste acceptera prisinformation": "Du måste acceptera prisinformation",
  Bokningsvillkor: "Bokningsvillkor",
  "Samtliga priser är inklusive moms.": "Samtliga priser är inklusive moms.",
  "14 dagars ångerrätt. Om eleven hunnit påbörja terminen utgår faktura för de lektioner som redan varit samt en administrativ avgift om 200kr.":
    "14 dagars ångerrätt. Om eleven hunnit påbörja terminen utgår faktura för de lektioner som redan varit samt en administrativ avgift om 200kr.",
  "Betalning ska ske inom 30 dagar netto. Dröjsmålsränta är 6% och påminnelseavgiften 60kr.":
    "Betalning ska ske inom 30 dagar netto. Dröjsmålsränta är 6% och påminnelseavgiften 60kr.",
  "GDPR Policy": "GDPR Policy",
  "Vi delar inte våra kunders uppgifter med tredje parter. För att kunna fakturera behöver vi namn, adress och telefonnummer samt mejladress. Personnr behövs för Suzukiundervisning eftersom detta sker i samarbete med ett studieförbund.":
    "Vi delar inte våra kunders uppgifter med tredje parter. För att kunna fakturera behöver vi namn, adress och telefonnummer samt mejladress. Personnr behövs för Suzukiundervisning eftersom detta sker i samarbete med ett studieförbund.",
  "Vi lagrar bara personuppgifter så länge personen är kund hos oss. Om kundrelationen avslutas behåller vi uppgifter i upp till två år.":
    "Vi lagrar bara personuppgifter så länge personen är kund hos oss. Om kundrelationen avslutas behåller vi uppgifter i upp till två år.",
  "Planerad frånvaro/sjukfrånvaro:": "Planerad frånvaro/sjukfrånvaro:",
  "Upp till 2 lektioner kan ersättas vid sjukdom. Det kan krävas lite flexibilitet av eleven om man vill ta igen en missad lektion.":
    "Upp till 2 lektioner kan ersättas vid sjukdom. Det kan krävas lite flexibilitet av eleven om man vill ta igen en missad lektion.",
  "Om man i god tid i förväg meddelar att man kommer vara frånvarande och pedagogen har möjlighet att hitta ett annat lektionstillfälle går detta bra. Det är dock inte givet att man kommer kunna hitta en ersättningstid. Det finns ingen möjlighet att ta igen missade lektioner som man inte meddelat i förväg (om det inte gäller sjukfrånvaro).":
    "Om man i god tid i förväg meddelar att man kommer vara frånvarande och pedagogen har möjlighet att hitta ett annat lektionstillfälle går detta bra. Det är dock inte givet att man kommer kunna hitta en ersättningstid. Det finns ingen möjlighet att ta igen missade lektioner som man inte meddelat i förväg (om det inte gäller sjukfrånvaro).",

  "Simone Trollmo är en violinist och fiollärare i Stockholm.":
    "Simone Trollmo är en violinist och fiollärare i Stockholm.",
  "Vill du lära dig fiol i vuxen ålder eller vill ditt barn spela suzukifiol enligt Suzukimetoden? Hos Stockholm Stråkstudio finns undervisning i fiol till barn och vuxna i Stockholm. För närvarande finns fiolundervisning i Bromma, Vällingby samt i Solna.":
    "Vill du lära dig fiol i vuxen ålder eller vill ditt barn spela suzukifiol enligt Suzukimetoden? Hos Stockholm Stråkstudio finns undervisning i fiol till barn och vuxna i Stockholm. För närvarande finns fiolundervisning i Bromma, Vällingby samt i Solna.",
  "Undervisning i fiol och cello enligt Suzukimetoden™️":
    "Undervisning i fiol och cello enligt Suzukimetoden™️",
  "Undervisning i fiol och cello i Stockholm för barn från 3 år och uppåt. För närvarande finns vi i Bromma, Vällingby samt i Solna.":
    "Undervisning i fiol och cello i Stockholm för barn från 3 år och uppåt. För närvarande finns vi i Bromma, Vällingby samt i Solna.",
  "Observera att det bara finns enstaka platser kvar på fiol. Ställ gärna ert barn i kö för att försäkra er om en plats":
    "Observera att det bara finns enstaka platser kvar på fiol. Ställ gärna ert barn i kö för att försäkra er om en plats",
  "Simone är utbildad violinist och fiollärare samt även certifierad Suzukilärare.":
    "Simone är utbildad violinist och fiollärare samt även certifierad Suzukilärare.",

  Plats: "Plats",
  "Ange plats...": "Ange plats...",
  "Måndagar: Kristofferskolan vid Brommaplan":
    "Måndagar: Kristofferskolan vid Brommaplan",
  "Onsdagar, Torsdagar, Lördagar: Rättar Vigs Väg i Vällingby":
    "Onsdagar, Torsdagar, Lördagar: Rättar Vigs Väg i Vällingby",
  "Onsdagar, Torsdagar, Rättar Vigs Väg i Vällingby":
    "Onsdagar, Torsdagar, Rättar Vigs Väg i Vällingby",
  "Fredagar: Hagaskolan i Hagalund": "Fredagar: Hagaskolan i Hagalund",

  Waldorfdockor: "Waldorfdockor",
  "Fiollektioner i Stockholm för barn och vuxna":
    "Fiollektioner i Stockholm för barn och vuxna",
  Textilkonstnär: "Textilkonstnär",
  "Syr waldorfdockor på beställning": "Syr waldorfdockor på beställning",
  "Vill du lära dig spela fiol?": "Vill du lära dig spela fiol?",
  "Jag erbjuder fiollektioner för barn och vuxna.":
    "Jag erbjuder fiollektioner för barn och vuxna.",
  "Kontakta oss": "Kontakta oss",
  "All rights reserved": "All rights reserved",
  "gjord av": "gjord av",
  "läs vår": "läs vår",
  "läs mer": "läs mer",
  integritetspolicy: "integritetspolicy",
  "Emanuel Franzen": "Emanuel Franzen",
  "Fiollektioner i Stockholm": "Fiollektioner i Stockholm",
  "Fiollektioner för barn & ungdom i Stockholm hos Stockholm Stråkstudio":
    "Fiollektioner för barn & ungdom i Stockholm hos Stockholm Stråkstudio",
  "Obs att flera av dagarna listade nedan är fullbelagda men det går bra att ställa sig i kö ":
    "Obs att flera av dagarna listade nedan är fullbelagda men det går bra att ställa sig i kö ",
  "Lördagar: Kristofferskolan vid Brommaplan":
    "Lördagar: Kristofferskolan vid Brommaplan",
  "Pojke tar fiollektioner i Stockholm": "Pojke tar fiollektioner i Stockholm",
  "Söker du en fiollärare i Stockholm?": "Söker du en fiollärare i Stockholm?",
  "Simone är utbildad violinist och har sedan vidareutbildat sig till fiollärare vid Stockholms Musikpedagogiska Institut för Päivikki Wirkkala Malmqvist. Simone är också utbildad Suzukilärare i fiol och erbjuder även Suzukifiol vilket du också kan läsa om ":
    "Simone är utbildad violinist och har sedan vidareutbildat sig till fiollärare vid Stockholms Musikpedagogiska Institut för Päivikki Wirkkala Malmqvist. Simone är också utbildad Suzukilärare i fiol och erbjuder även Suzukifiol vilket du också kan läsa om ",
  "Simone är utbildad violinist och har sedan vidareutbildat sig till fiollärare vid Stockholms Musikpedagogiska Institut för Päivikki Wirkkala Malmqvist. Simone är också utbildad Suzukilärare i fiol och erbjuder även Suzukifiol vilket du också kan läsa om här på sidan.":
    "Simone är utbildad violinist och har sedan vidareutbildat sig till fiollärare vid Stockholms Musikpedagogiska Institut för Päivikki Wirkkala Malmqvist. Simone är också utbildad Suzukilärare i fiol och erbjuder även Suzukifiol vilket du också kan läsa om här på sidan.",
  här: "här",
  ".": ".",
  "I Simones fiolundervisning läggs stor vikt vid ergonomi och att bygga bra grunder för violintekniken. Spelandet ska vara lustfyllt vilket kräver en god relation mellan lärare, elev och förälder samt en trygg miljö. Föräldern närvarar alltid vid lektionerna samt övar med barnet hemma. För att lära sig ett instrument krävs frekvent övning, helst varje dag!":
    "I Simones fiolundervisning läggs stor vikt vid ergonomi och att bygga bra grunder för violintekniken. Spelandet ska vara lustfyllt vilket kräver en god relation mellan lärare, elev och förälder samt en trygg miljö. Föräldern närvarar alltid vid lektionerna samt övar med barnet hemma. För att lära sig ett instrument krävs frekvent övning, helst varje dag!",
  "Fiolundervisningen sker främst i Bromma samt en dag i centrala Stockholm (för närvarande lördagar). Till vårterminen 2024 planerar Simone också att börja undervisa vid Hagaskolan i Hagalund, Solna, om det finns tillräckligt med intresse.":
    "Fiolundervisningen sker främst i Bromma samt en dag i centrala Stockholm (för närvarande lördagar). Till vårterminen 2024 planerar Simone också att börja undervisa vid Hagaskolan i Hagalund, Solna, om det finns tillräckligt med intresse.",
  "Hör av dig via kontaktformuläret här ovan om du är intresserad av fiollektioner.":
    "Hör av dig via kontaktformuläret här ovan om du är intresserad av fiollektioner.",
  "Hör av dig via kontaktformuläret om du är intresserad av celloundervisning.":
    "Hör av dig via kontaktformuläret om du är intresserad av celloundervisning.",
  Priser: "Priser",
  "Priser VT 2024, 15 undervisningstillfällen. Utöver detta tillkommer en avgift om 175:- för elevkonsert. Alla priser är inkl. moms.":
    "Priser VT 2024, 15 undervisningstillfällen. Utöver detta tillkommer en avgift om 175:- för elevkonsert. Alla priser är inkl. moms.",

  Längd: "Längd",
  "Pris (kr)": "Pris (kr)",
  "Kontakta oss gärna.": "Kontakta oss gärna.",
  Namn: "Namn",
  Telefonnummer: "Telefonnummer",
  Ämne: "Ämne",
  Meddelande: "Meddelande",
  Skicka: "Skicka",
  "Meddelande skickat!": "Meddelande skickat!",
  "Tack för ditt meddelande. Jag hör av mig så snart jag kan.":
    "Tack för ditt meddelande. Jag hör av mig så snart jag kan.",
  "Meddelande kunde inte skickas!": "Meddelande kunde inte skickas!",
  "Anmälan skickad!": "Anmälan skickad!",
  "Tack för din anmälan. Jag återkommer av mig så snart jag kan.":
    "Tack för din anmälan. Jag återkommer av mig så snart jag kan.",
  "Nytt meddelande från": "Nytt meddelande från",
  "Namn: ": "Namn: ",
  "Email: ": "Email: ",
  "Telefonnummer: ": "Telefonnummer: ",
  "Meddelande: ": "Meddelande: ",
  "Besök strakstudio.se": "Besök strakstudio.se",

  "Hej, välkommen tillbaka!": "Hej, välkommen tillbaka!",

  Karta: "Karta",
  "Kartan kunde inte laddas.": "Kartan kunde inte laddas.",
  "Söker du en fiollärare för ditt barn i Stockholm?":
    "Söker du en fiollärare för ditt barn i Stockholm?",
  "Fiolundervisningen finns i Bromma, Solna samt från och med höstterminen 2024 även i Vällingby.":
    "Fiolundervisningen finns i Bromma, Solna samt från och med höstterminen 2024 även i Vällingby.",
  "Priser VT 2026, 14 undervisningstillfällen. Alla priser är inkl. moms.":
    "Priser VT 2026, 14 undervisningstillfällen. Alla priser är inkl. moms.",
  "Priser, VT 2026, 14 lektioner inkl. moms:":
    "Priser, VT 2026, 14 lektioner inkl. moms:",
  "Om Simone": "Om Simone",
  "Om David": "Om David",
  "Om oss": "Om oss",
  "David är cellist utbildad som musiklärare med cello inriktning i Universidad Tecnológica de Pereira i sitt hemland Colombia och har sedan vidareutbildat som cellist i masterprogram I Longy School of Music, USA för Terry King. David är också utbildad som Suzukilärare och erbjuder också Suzukicello. David har stort intresse för alla musikgenrer och spelstilar från klassisk till pop och rock och allt däremellan. Som en cellist med en sena startsträcka, David har som största syfte att dela musik med alla oavsett deras ålder eller bakgrund och I många år har han jobbat med El Sistema filosofi I Colombia, USA och Sverige, där musik används som ett verktyg till social utveckling. Han är för närvarande cellolärare vid Sundbybergs Kulturskola och Stockholms Stråkstudio.":
    "David är cellist utbildad som musiklärare med cello inriktning i Universidad Tecnológica de Pereira i sitt hemland Colombia och har sedan vidareutbildat som cellist i masterprogram I Longy School of Music, USA för Terry King. David är också utbildad som Suzukilärare och erbjuder också Suzukicello. David har stort intresse för alla musikgenrer och spelstilar från klassisk till pop och rock och allt däremellan. Som en cellist med en sena startsträcka, David har som största syfte att dela musik med alla oavsett deras ålder eller bakgrund och I många år har han jobbat med El Sistema filosofi I Colombia, USA och Sverige, där musik används som ett verktyg till social utveckling. Han är för närvarande cellolärare vid Sundbybergs Kulturskola och Stockholms Stråkstudio.",
  'Stockholms Stråkstudios grundare Simone Trollmo är en violinist baserad i Stockholm som gärna utforskar den breda repertoar som finns för violin och särskilt det utrymme för improvisation och frihet som finns inom barockmusiken. Hon har studerat vid Trinity Laban Conservatoire i London och sedan specialiserat sig inom barockmusik vid Longy School of Music of Bard College i Boston, med en senare doktorand-utbildning vid Boston University. Hennes avhandling "A Method-Based Approach to Historical Violin Playing: Performance Practice from a Contemporary Perspective" finns tillgänglig online.':
    'Stockholms Stråkstudios grundare Simone Trollmo är en violinist baserad i Stockholm som gärna utforskar den breda repertoar som finns för violin och särskilt det utrymme för improvisation och frihet som finns inom barockmusiken. Hon har studerat vid Trinity Laban Conservatoire i London och sedan specialiserat sig inom barockmusik vid Longy School of Music of Bard College i Boston, med en senare doktorand-utbildning vid Boston University. Hennes avhandling "A Method-Based Approach to Historical Violin Playing: Performance Practice from a Contemporary Perspective" finns tillgänglig online.',
  "Simone har ett stort intresse för kammarmusik och har varit med och grundat Ensemble Sol & Måne som för tillfället är aktuella med en ny barnföreställning.":
    "Simone har ett stort intresse för kammarmusik och har varit med och grundat Ensemble Sol & Måne som för tillfället är aktuella med en ny barnföreställning.",
  "Förutom det egna spelet har Simone ett stort engagemang för pedagogik och brinner för att dela sin glädje för musiken med andra människor. Simone har vidareutbildat sig vid Stockholms Musikpedagogiska Institut och sedan specialiserat sig som Suzukilärare med Päivikki Wirkkala Malmqvist och Jan Matthiesen. Hon har även gått fortbildningskurser i bl a Colourstrings-metoden som är baserad på Kódaly metodik som även fortsättningsvis inspirerar hennes undervisning. Hon har tidigare bl a undervisat vid Kulturskolan Stockholm, Medborgarskolan Lidingö samt New School of Music i Cambridge, MA.":
    "Förutom det egna spelet har Simone ett stort engagemang för pedagogik och brinner för att dela sin glädje för musiken med andra människor. Simone har vidareutbildat sig vid Stockholms Musikpedagogiska Institut och sedan specialiserat sig som Suzukilärare med Päivikki Wirkkala Malmqvist och Jan Matthiesen. Hon har även gått fortbildningskurser i bl a Colourstrings-metoden som är baserad på Kódaly metodik som även fortsättningsvis inspirerar hennes undervisning. Hon har tidigare bl a undervisat vid Kulturskolan Stockholm, Medborgarskolan Lidingö samt New School of Music i Cambridge, MA.",
  "Lär dig spela fiol enligt Suzuki™metoden!":
    "Lär dig spela fiol enligt Suzuki™metoden!",
  "Lär dig suzukifiol i Stockholm!": "Lär dig suzukifiol i Stockholm!",
  "För att ställa dig i kö till Suzukifiol, klicka här":
    "För att ställa dig i kö till Suzukifiol, klicka här",
  "Alla barn kan lära sig ett instrument! Spela fiol enligt suzukimetoden för Simone som är certifierad Suzukilärare. Spelar man Suzukifiol ses man två gånger i veckan för en individuell lektion och en grupplektion. Metoden bygger på samarbete och tillit mellan barn, förälder och lärare. Föräldern är viktig del av undervisningen och undervisar barnet i hemmet mellan lektionerna.":
    "Alla barn kan lära sig ett instrument! Spela fiol enligt suzukimetoden för Simone som är certifierad Suzukilärare. Spelar man Suzukifiol ses man två gånger i veckan för en individuell lektion och en grupplektion. Metoden bygger på samarbete och tillit mellan barn, förälder och lärare. Föräldern är viktig del av undervisningen och undervisar barnet i hemmet mellan lektionerna.",
  "Flicka lär sig spela fiol med suzukimetoden i Stockholm":
    "Flicka lär sig spela fiol med suzukimetoden i Stockholm",
  "Suzuki™metoden kallas också för modersmålsmetoden och bygger på principen att man kan lära sig ett instrument på samma sätt som man lär sig att tala. Metoden utvecklades av Shin’ichi Suzuki i Japan efter andra världskriget och har sedan spridit sig över världen. En viktig del i filosofin är att alla barn har talang: liksom alla barn kan lära sig prata kan alla barn lära sig att spela ett instrument. Eftersom man lär sig på samma sätt som man lär sig tala, genom imitation, börjar man tidigt. En bra lucka att börja i är mellan 3-6 års ålder men Simone tar emot barn i alla åldrar.":
    "Suzuki™metoden kallas också för modersmålsmetoden och bygger på principen att man kan lära sig ett instrument på samma sätt som man lär sig att tala. Metoden utvecklades av Shin’ichi Suzuki i Japan efter andra världskriget och har sedan spridit sig över världen. En viktig del i filosofin är att alla barn har talang: liksom alla barn kan lära sig prata kan alla barn lära sig att spela ett instrument. Eftersom man lär sig på samma sätt som man lär sig tala, genom imitation, börjar man tidigt. En bra lucka att börja i är mellan 3-6 års ålder men Simone tar emot barn i alla åldrar.",
  "Eftersom små barn lär sig bäst genom imitation sker undervisningen först på gehör. Att lyssna på inspelningar med Suzuki™-repertoaren hemma är obligatoriskt och snabbar på inlärningen. Precis som vid inlärningen av modersmålet ska musiken finnas i omgivningen så mycket som möjligt.":
    "Eftersom små barn lär sig bäst genom imitation sker undervisningen först på gehör. Att lyssna på inspelningar med Suzuki™-repertoaren hemma är obligatoriskt och snabbar på inlärningen. Precis som vid inlärningen av modersmålet ska musiken finnas i omgivningen så mycket som möjligt.",
  "En annan viktig byggsten är repetition av redan inlärd repertoar. Till skillnad från många andra fiolböcker så stiger varje stycke i Suzuki™-repertoaren i svårighetsgrad. Genom att hela tiden repetera alla stycken som man lärt sig, tar man lättare till sig det nya stycket. Man har dessutom en gemensam repertoar med andra som också undervisas enligt metoden som gör att man lätt kan spela tillsammans på konserter - var som helst i världen. Ibland kan man som elev eller förälder förledas att jämföra sig/sitt barn med var andra befinner sig i böckerna. Det är viktigt att påpeka att alla barn lär sig i sin egen takt och behöver få den tid på sig att mogna som just de behöver.":
    "En annan viktig byggsten är repetition av redan inlärd repertoar. Till skillnad från många andra fiolböcker så stiger varje stycke i Suzuki™-repertoaren i svårighetsgrad. Genom att hela tiden repetera alla stycken som man lärt sig, tar man lättare till sig det nya stycket. Man har dessutom en gemensam repertoar med andra som också undervisas enligt metoden som gör att man lätt kan spela tillsammans på konserter - var som helst i världen. Ibland kan man som elev eller förälder förledas att jämföra sig/sitt barn med var andra befinner sig i böckerna. Det är viktigt att påpeka att alla barn lär sig i sin egen takt och behöver få den tid på sig att mogna som just de behöver.",
  "När man undervisas enligt Suzuki™metoden har man både individuella lektioner varje vecka samt grupplektioner. Under grupplektionerna kan man repetera redan inlärd teknik men också få chansen till samspel och att stärka de sociala banden. Det är en stor fördel att få se en lärare två gånger i veckan och den sociala aspekten är mycket betydelsefull.":
    "När man undervisas enligt Suzuki™metoden har man både individuella lektioner varje vecka samt grupplektioner. Under grupplektionerna kan man repetera redan inlärd teknik men också få chansen till samspel och att stärka de sociala banden. Det är en stor fördel att få se en lärare två gånger i veckan och den sociala aspekten är mycket betydelsefull.",
  "Föräldern är mycket viktig i Suzuki™metoden. Den närvarar vid alla fiollektioner både individuella och i grupp, observerar och noterar och övar med barnet hemma. Innan barnet börjar med sina lektioner får därför föräldern gå en föräldrakurs där hen får lära sig grunderna på instrumentet samt lite om filosofin bakom metoden.":
    "Föräldern är mycket viktig i Suzuki™metoden. Den närvarar vid alla fiollektioner både individuella och i grupp, observerar och noterar och övar med barnet hemma. Innan barnet börjar med sina lektioner får därför föräldern gå en föräldrakurs där hen får lära sig grunderna på instrumentet samt lite om filosofin bakom metoden.",
  "Priser: Priser inkluderar inviduella lektioner x 14 samt grupplektioner om 45min x 14.":
    "Priser: Priser inkluderar inviduella lektioner x 14 samt grupplektioner om 45min x 14.",
  "Enbart gruppspel (obs att gruppspel ingår i avgifterna ovan, detta är för elever som inte tar individuella lektioner hos oss): 1500:-":
    "Enbart gruppspel (obs att gruppspel ingår i avgifterna ovan, detta är för elever som inte tar individuella lektioner hos oss): 1500:-",
  "Gruppspel syskon: 1000:-": "Gruppspel syskon: 1000:-",
  "Syskon kan dela på 30, 45 eller 60min men måste då köpa till gruppspel för det syskonet/syskonen.":
    "Syskon kan dela på 30, 45 eller 60min men måste då köpa till gruppspel för det syskonet/syskonen.",
  "Om du är intresserad av Suzukifiol, Kontakta oss på länken ovan.":
    "Om du är intresserad av Suzukifiol, Kontakta oss på länken ovan.",
  "Dockor i waldorfstil": "Dockor i waldorfstil",
  "Simone syr dockor i naturmaterial stoppade med certifierad ekologisk ull på beställning. Hon ger också kurser i hur man syr en waldorfdocka. Simone syr också födelsedagskronor i ullfilt som är nålfiltade och/eller broderade på beställning.":
    "Simone syr dockor i naturmaterial stoppade med certifierad ekologisk ull på beställning. Hon ger också kurser i hur man syr en waldorfdocka. Simone syr också födelsedagskronor i ullfilt som är nålfiltade och/eller broderade på beställning.",
  Prislista: "Prislista",
  Produkt: "Produkt",
  "Stor docka ca 40cm lång": "Stor docka ca 40cm lång",
  "Mellan docka ca 30cm lång": "Mellan docka ca 30cm lång",
  "Liten docka ca 20cm lång": "Liten docka ca 20cm lång",
  "Velourdocka ca 20cm lång": "Velourdocka ca 20cm lång",
  "Waldorfdocka för nyfödd i knytmodell":
    "Waldorfdocka för nyfödd i knytmodell",
  "Födelsedagskrona i ullfilt": "Födelsedagskrona i ullfilt",
  "Följ på Instagram": "Följ på Instagram",
  "Följ mig på Instagram": "Följ mig på Instagram",

  "Du måste ange namn": "Du måste ange namn",
  "För kort namn": "För kort namn",
  "Du måste ange mailadress": "Du måste ange mailadress",
  "Felaktig mailadress": "Felaktig mailadress",
  "Du måste ange telefonnummer": "Du måste ange telefonnummer",
  "Telefonnummer måste vara minst 7 siffror":
    "Telefonnummer måste vara minst 7 siffror",
  // Waiting List
  Kölista: "Kölista",
  "Namn barn": "Namn barn",
  Födelseår: "Födelseår",
  "Du måste ange födelseår": "Du måste ange födelseår",
  "Födelseår måste vara 4 siffror": "Födelseår måste vara 4 siffror",
  "Önskat startdatum (t ex HT 2026)": "Önskat startdatum (t ex HT 2026)",
  "Du måste ange önskat startdatum": "Du måste ange önskat startdatum",
  "Önskat startdatum": "Önskat startdatum",
  "Önskad undervisningsplats": "Önskad undervisningsplats",
  "Du måste välja undervisningsplats": "Du måste välja undervisningsplats",
  "Jag vill ställa mitt barn i kö till:":
    "Jag vill ställa mitt barn i kö till:",
  Suzukicello: "Suzukicello",
  Barnkör: "Barnkör",
  "Du måste välja minst ett alternativ": "Du måste välja minst ett alternativ",
  "Namn förälder": "Namn förälder",
  Kristofferskolan: "Kristofferskolan",
  Hagaskolan: "Hagaskolan",
  Vällingby: "Vällingby",
  "Kölista skickad!": "Kölista skickad!",
  "Tack för din anmälan till kölistan. Jag återkommer av mig så snart jag kan.":
    "Tack för din anmälan till kölistan. Jag återkommer av mig så snart jag kan.",
  "Ny kölista från": "Ny kölista från",
  "Barnets namn: ": "Barnets namn: ",
  "Födelseår: ": "Födelseår: ",
  "Önskat startdatum: ": "Önskat startdatum: ",
  "Önskad undervisningsplats: ": "Önskad undervisningsplats: ",
  Datum: "Datum",
  "ställ er i kö": "ställ er i kö",
  "Du måste ange ämne": "Du måste ange ämne",
  "Du måste ange meddelande": "Du måste ange meddelande",
  "Meddelandet måste vara minst 10 tecken":
    "Meddelandet måste vara minst 10 tecken",
  "Captcha-widgeten kunde inte laddas. Försök ladda om sidan.":
    "Captcha-widgeten kunde inte laddas. Försök ladda om sidan.",
  "Formuläret kan inte skickas utan att captcha är löst.":
    "Formuläret kan inte skickas utan att captcha är löst.",
  "Logga ut": "Logga ut",
  "Den sidan finns inte.": "Den sidan finns inte.",
  "Vi kunde inte hitta sidan du letade efter. Kanske är adressen felstavad? Var god kontrollera stavningen och försök igen.":
    "Vi kunde inte hitta sidan du letade efter. Kanske är adressen felstavad? Var god kontrollera stavningen och försök igen.",
  "Gå till startsidan": "Gå till startsidan",
  "Många föräldrar tycker att det är knepigt att komma igång med fiol-övningen hemma. Precis som med alla nya vanor tar det ett tag att etablera.":
    "Många föräldrar tycker att det är knepigt att komma igång med fiol-övningen hemma. Precis som med alla nya vanor tar det ett tag att etablera.",
  "Mitt största tips är att försöka göra det till en del av den dagliga rutinen. Helst ska man öva vid samma tillfälle varje dag (och välja ett sådant tillfälle att det faktiskt går att öva vid samma tid hela veckan, att det inte är en tid då man vissa dagar är borta för aktiviteter). Om barnet förväntar sig att övningen ska ske vid en viss tidpunkt varje dag, liksom hen behöver borsta tänderna morgon och kväll varje dag, brukar det bli mindre konflikter.":
    "Mitt största tips är att försöka göra det till en del av den dagliga rutinen. Helst ska man öva vid samma tillfälle varje dag (och välja ett sådant tillfälle att det faktiskt går att öva vid samma tid hela veckan, att det inte är en tid då man vissa dagar är borta för aktiviteter). Om barnet förväntar sig att övningen ska ske vid en viss tidpunkt varje dag, liksom hen behöver borsta tänderna morgon och kväll varje dag, brukar det bli mindre konflikter.",
  "Förälderns jobb är att om möjligt få barnet att känna att övningen är lustfylld och så rolig att hen VILL öva! Men vi är alla människor och det kommer inte vara så varje dag - känn ingen stress över detta eller tänk att ni har misslyckats. Det kommer att komma bra övningsstunder och mindre bra övningsstunder, det är helt okej!":
    "Förälderns jobb är att om möjligt få barnet att känna att övningen är lustfylld och så rolig att hen VILL öva! Men vi är alla människor och det kommer inte vara så varje dag - känn ingen stress över detta eller tänk att ni har misslyckats. Det kommer att komma bra övningsstunder och mindre bra övningsstunder, det är helt okej!",
  "Att lusten att öva går upp och ned betyder inte att barnet inte gillar att spela sitt instrument i stort. Det speglar mer dagsform och var barnet befinner sig i sin utveckling.":
    "Att lusten att öva går upp och ned betyder inte att barnet inte gillar att spela sitt instrument i stort. Det speglar mer dagsform och var barnet befinner sig i sin utveckling.",
  "Några konkreta övningstips:": "Några konkreta övningstips:",
  "Mindre barn älskar lekar i alla dess former. Det spelar ingen roll hur ”konstig” leken än är (föräldern kanske är trött och har brist på fantasi), så länge barnet gillar den och är mera villig att öva är allt bra! Här kommer några exempel på lekar:":
    "Mindre barn älskar lekar i alla dess former. Det spelar ingen roll hur ”konstig” leken än är (föräldern kanske är trött och har brist på fantasi), så länge barnet gillar den och är mera villig att öva är allt bra! Här kommer några exempel på lekar:",
  "Samla poäng för varje genomfört element/stycke. T ex leksaker, duplobitar (vi brukar bygga torn), mynt, chokladpengar…. Snåla inte :)":
    "Samla poäng för varje genomfört element/stycke. T ex leksaker, duplobitar (vi brukar bygga torn), mynt, chokladpengar…. Snåla inte :)",
  "Tävlingar i alla dess former, föräldern mot barnet (men se till att barnet vinner, utan att det är alltför uppenbart!).":
    "Tävlingar i alla dess former, föräldern mot barnet (men se till att barnet vinner, utan att det är alltför uppenbart!).",
  "Gosedjur/legogubbar etc som är kontrollanter av den teknik man för tillfället jobbar med.":
    "Gosedjur/legogubbar etc som är kontrollanter av den teknik man för tillfället jobbar med.",
  "Olika typer av rollspel, använd gärna olika röster!":
    "Olika typer av rollspel, använd gärna olika röster!",
  "Barn vill som bekant gärna bestämma själva. Låt barnet få vara delaktig i sin övningsstund från första början genom att t ex bestämma ordningen på styckena som hen spelar. Eller ge ett val av två stycken som behandlar samma teknik: ”Vill du spela x stycke eller y stycke?”":
    "Barn vill som bekant gärna bestämma själva. Låt barnet få vara delaktig i sin övningsstund från första början genom att t ex bestämma ordningen på styckena som hen spelar. Eller ge ett val av två stycken som behandlar samma teknik: ”Vill du spela x stycke eller y stycke?”",
  "Var lyhörd för dagsform och känn efter när det är dags att sluta - det är inte värt att övningsstunden får ett dåligt slut för att få in det där sista stycket eller för att man absolut skulle öva ett stycke man fått i läxa som barnet inte vill spela den dagen. (Talar av egen erfarenhet!)":
    "Var lyhörd för dagsform och känn efter när det är dags att sluta - det är inte värt att övningsstunden får ett dåligt slut för att få in det där sista stycket eller för att man absolut skulle öva ett stycke man fått i läxa som barnet inte vill spela den dagen. (Talar av egen erfarenhet!)",
  "Äldre barn kan få ännu mer egen kontroll genom att skriva upp övningslistor, s.k. charts, och kryssa i när man övat något. Ju äldre barn, ju mera eget ansvar för sitt övande. Vilket inte ska förleda en att tro att barnen kan vara helt självgående i övningen. Min erfarenhet är att upp till och med mellanstadie-åldern, och i vissa fall ännu längre, är det en stor fördel om föräldrar är med både på lektioner samt assisterar med övningen hemma.":
    "Äldre barn kan få ännu mer egen kontroll genom att skriva upp övningslistor, s.k. charts, och kryssa i när man övat något. Ju äldre barn, ju mera eget ansvar för sitt övande. Vilket inte ska förleda en att tro att barnen kan vara helt självgående i övningen. Min erfarenhet är att upp till och med mellanstadie-åldern, och i vissa fall ännu längre, är det en stor fördel om föräldrar är med både på lektioner samt assisterar med övningen hemma.",
  "Att få spela med andra barn är en viktig del av motivationen. Jag kan inte nog betona hur viktiga grupplektioner är av denna anledning. Här får barnen träffa andra barn som sätter spelandet i ett socialt sammanhang. Att arbeta i grupp ger många möjligheter som man inte har tillgång till när man har enskild lektion. Plus att det är så roligt att spela tillsammans!":
    "Att få spela med andra barn är en viktig del av motivationen. Jag kan inte nog betona hur viktiga grupplektioner är av denna anledning. Här får barnen träffa andra barn som sätter spelandet i ett socialt sammanhang. Att arbeta i grupp ger många möjligheter som man inte har tillgång till när man har enskild lektion. Plus att det är så roligt att spela tillsammans!",

  "Tyvärr, den sidan finns inte!": "Tyvärr, den sidan finns inte!",
  "Vi kunde inte hitta sidan du letar efter. Kanske har du skrivit fel i URL:en? Var noga med att kolla stavningen.":
    "Vi kunde inte hitta sidan du letar efter. Kanske har du skrivit fel i URL:en? Var noga med att kolla stavningen.",
  "Gå tillbaka": "Gå tillbaka",

  // privacy-policy
  "Integritetspolicy för strakstudio.se":
    "Integritetspolicy för strakstudio.se",
  "Senast uppdaterad: 2024-01-10": "Senast uppdaterad: 2024-01-10",
  "1. Inledning": "1. Inledning",
  "Välkommen till strakstudio.se. Vi är engagerade i att skydda integriteten för våra användare och besökare. Denna integritetspolicy beskriver våra metoder för insamling, användning och delning av din personliga information.":
    "Välkommen till strakstudio.se. Vi är engagerade i att skydda integriteten för våra användare och besökare. Denna integritetspolicy beskriver våra metoder för insamling, användning och delning av din personliga information.",
  "2. Insamling av Data": "2. Insamling av Data",
  "a. För Alla Användare och Besökare:": "a. För Alla Användare och Besökare:",
  "Vi samlar in information som du tillhandahåller när du interagerar med vår webbplats, till exempel när du fyller i formulär eller skickar meddelanden.":
    "Vi samlar in information som du tillhandahåller när du interagerar med vår webbplats, till exempel när du fyller i formulär eller skickar meddelanden.",
  "Vi samlar automatiskt in viss information när du besöker vår webbplats, såsom din IP-adress och webbläsartyp.":
    "Vi samlar automatiskt in viss information när du besöker vår webbplats, såsom din IP-adress och webbläsartyp.",
  "b. För Administratörer:": "b. För Administratörer:",
  "Utöver ovanstående kan administratörer tillhandahålla ytterligare personlig information som krävs för kontohantering och autentisering.":
    "Utöver ovanstående kan administratörer tillhandahålla ytterligare personlig information som krävs för kontohantering och autentisering.",
  "3. Användning av Data": "3. Användning av Data",
  "Vi använder din information för att tillhandahålla och förbättra våra tjänster, svara på dina förfrågningar och hantera vår webbplats.":
    "Vi använder din information för att tillhandahålla och förbättra våra tjänster, svara på dina förfrågningar och hantera vår webbplats.",
  "Vi kan använda din e-postadress för att kommunicera med dig, om du har valt att ta emot kommunikation från oss.":
    "Vi kan använda din e-postadress för att kommunicera med dig, om du har valt att ta emot kommunikation från oss.",
  "Vi använder din information för att möjliggöra administrativa funktioner, inklusive att läsa och svara på användarmeddelanden.":
    "Vi använder din information för att möjliggöra administrativa funktioner, inklusive att läsa och svara på användarmeddelanden.",
  "Administratörer kan använda en tredjepartstjänst (t.ex. Gmail) för att skicka svar. Vi ser till att dessa tjänster följer våra integritetsstandarder.":
    "Administratörer kan använda en tredjepartstjänst (t.ex. Gmail) för att skicka svar. Vi ser till att dessa tjänster följer våra integritetsstandarder.",
  "4. Delning av Data": "4. Delning av Data",
  "Vi säljer eller hyr inte ut dina personuppgifter till tredje part.":
    "Vi säljer eller hyr inte ut dina personuppgifter till tredje part.",
  "Vi kan dela din information med tredjepartsleverantörer för att utföra tjänster på våra vägnar, såsom webbhotell eller e-postkommunikation.":
    "Vi kan dela din information med tredjepartsleverantörer för att utföra tjänster på våra vägnar, såsom webbhotell eller e-postkommunikation.",
  "Vi kan avslöja din information om det krävs enligt lag eller om det är nödvändigt för att skydda våra rättigheter eller säkerheten för andra.":
    "Vi kan avslöja din information om det krävs enligt lag eller om det är nödvändigt för att skydda våra rättigheter eller säkerheten för andra.",
  "5. Användares Rättigheter": "5. Användares Rättigheter",
  "Du har rätt att få tillgång till, korrigera eller radera din personliga information.":
    "Du har rätt att få tillgång till, korrigera eller radera din personliga information.",
  "Du kan när som helst välja att inte ta emot marknadsföringskommunikation från oss.":
    "Du kan när som helst välja att inte ta emot marknadsföringskommunikation från oss.",
  "6. Ändringar av Denna Policy": "6. Ändringar av Denna Policy",
  "Vi kan uppdatera denna policy från tid till annan. Vi kommer att meddela dig om eventuella ändringar genom att publicera den nya policyn på denna sida.":
    "Vi kan uppdatera denna policy från tid till annan. Vi kommer att meddela dig om eventuella ändringar genom att publicera den nya policyn på denna sida.",
  "7. Kontakta Oss": "7. Kontakta Oss",
  "Om du har några frågor om denna integritetspolicy, vänligen kontakta oss på strakstudio.se, via kontaktformuläret.":
    "Om du har några frågor om denna integritetspolicy, vänligen kontakta oss på strakstudio.se, via kontaktformuläret.",

  // Dashboard - Messages
  Från: "Från",
  Mejl: "Mejl",
  "Laddar...": "Laddar...",
  "Inga meddelanden hittades": "Inga meddelanden hittades",
  "Email kopierad till urklipp": "Email kopierad till urklipp",
  "Kopiera email": "Kopiera email",
  Telefon: "Telefon",
  Stäng: "Stäng",
  "Visar X till Y av Z meddelanden": "Visar X till Y av Z meddelanden",
  Föregående: "Föregående",
  Nästa: "Nästa",
  "Sida X av Y": "Sida X av Y",
  Databasfel: "Databasfel",
  "Kunde inte ladda meddelanden från databasen. Försök igen senare.":
    "Kunde inte ladda meddelanden från databasen. Försök igen senare.",
  "Försök igen": "Försök igen",
  "Meddelandet har tagits bort": "Meddelandet har tagits bort",
  "Ta bort": "Ta bort",
  Validering: "Validering",
  "Är du säker på att du vill ta bort det här meddelandet från":
    "Är du säker på att du vill ta bort det här meddelandet från",
  Avbryt: "Avbryt",

  // Dashboard - Video Library
  "Ny video": "Ny video",
  "Lägg till ny video": "Lägg till ny video",
  "Lägg till en ny video i videobiblioteket.":
    "Lägg till en ny video i videobiblioteket.",
  Titel: "Titel",
  Beskrivning: "Beskrivning",
  "Video-ID": "Video-ID",
  "Lägg till": "Lägg till",
  Tillagd: "Tillagd!",
  "Något gick fel": "Något gick fel",
  Miniatyr: "Miniatyr",
  Åtgärder: "Åtgärder",
  Redigera: "Redigera",
  "Video-ID kopierat": "Video-ID kopierat",
  "Kopiera video-ID": "Kopiera video-ID",
  'Kopierade "{videoId}" till urklipp': 'Kopierade "{videoId}" till urklipp',
  "Kunde inte kopiera": "Kunde inte kopiera",
  "Kunde inte kopiera video-ID till urklipp":
    "Kunde inte kopiera video-ID till urklipp",
  "Inga videor valda": "Inga videor valda",
  "X video(r) valda": "X video(r) valda",
  "Ta bort valda": "Ta bort valda",
  "Ta bort valda videor": "Ta bort valda videor",
  "Är du säker på att du vill ta bort X video(r)? Denna åtgärd kan inte ångras.":
    "Är du säker på att du vill ta bort X video(r)? Denna åtgärd kan inte ångras.",
  "Ta bort X video(r)": "Ta bort X video(r)",
  "Redigera video": "Redigera video",
  "Uppdatera videoinformation.": "Uppdatera videoinformation.",
  Uppdatera: "Uppdatera",
  Uppdaterad: "Uppdaterad!",
  "Kunde inte ladda videor från databasen. Försök igen senare.":
    "Kunde inte ladda videor från databasen. Försök igen senare.",

  // Dashboard - Analytics
  "Välkommen tillbaka!": "Välkommen tillbaka!",
  "Detta är strakstudio.se's dashboardvy, som ger insikter om våra användare och applikationstrender.":
    "Detta är strakstudio.se's dashboardvy, som ger insikter om våra användare och applikationstrender.",
  "Totalt antal besökare": "Totalt antal besökare",
  "Totalt antal registrerade användare": "Totalt antal registrerade användare",
  "Totalt antal meddelanden": "Totalt antal meddelanden",
  Ny: "Ny",
  "Ingen förändring": "Ingen förändring",
  "Antal unika besökare varje dag": "Antal unika besökare varje dag",
  "Ny mätmetod": "Ny mätmetod",
  "Besök efter enhet": "Besök efter enhet",
  "Besök efter kanal": "Besök efter kanal",
  "Google organiskt": "Google organiskt",
  "Annan sökmotor": "Annan sökmotor",
  "Facebook och Instagram": "Facebook och Instagram",
  "Annan social": "Annan social",
  Direkt: "Direkt",
  "Egna domäner": "Egna domäner",
  "Annan hänvisning": "Annan hänvisning",
  "Föregående period": "Föregående period",
  "Visa hänvisare": "Visa hänvisare",
  "Dölj hänvisare": "Dölj hänvisare",
  "Ingen trafik än": "Ingen trafik än",
  "Besök efter land": "Besök efter land",
  "Fel vid laddning av data": "Fel vid laddning av data",
  "Ingen data för perioden": "Ingen data för perioden",
  "vs föregående period": "vs föregående period",
  "Antal unika besökare varje vecka": "Antal unika besökare varje vecka",
  "Unika besökare per kanal": "Unika besökare per kanal",
  "Mest lästa sidorna": "Mest lästa sidorna",
  "Besökare per språk": "Besökare per språk",
  "Från besök till inskickat formulär": "Från besök till inskickat formulär",

  // Dashboard - Date range
  Period: "Period",
  "7 dagar": "7 dagar",
  "30 dagar": "30 dagar",
  "90 dagar": "90 dagar",
  "Denna termin": "Denna termin",
  "Förra terminen": "Förra terminen",
  Till: "Till",
  "Jämfört med": "Jämfört med",

  // Dashboard - Top pages and language split
  Toppsidor: "Toppsidor",
  Sida: "Sida",
  Besökare: "Besökare",
  Sidvisningar: "Sidvisningar",
  Ingångar: "Ingångar",
  "Visa alla": "Visa alla",
  Alla: "Alla",
  Svenska: "Svenska",
  Engelska: "Engelska",
  Språkfördelning: "Språkfördelning",
  Okänd: "Okänd",

  // Dashboard - Search Console
  Sökprestanda: "Sökprestanda",
  "Från Google Search Console": "Från Google Search Console",
  Klick: "Klick",
  Visningar: "Visningar",
  CTR: "CTR",
  Snittposition: "Snittposition",
  Toppsökord: "Toppsökord",
  "Toppsidor i sök": "Toppsidor i sök",
  Sökord: "Sökord",
  Position: "Position",
  "Bevakat sökord": "Bevakat sökord",
  "Data t.o.m.": "Data t.o.m.",
  "Senaste synkningen misslyckades": "Senaste synkningen misslyckades",
  "Search Console är inte kopplad": "Search Console är inte kopplad",
  "Sätt GOOGLE_SEARCH_CONSOLE_CREDENTIALS och SEARCH_CONSOLE_SITE_URL, och lägg till tjänstekontot som användare på egendomen i Search Console.":
    "Sätt GOOGLE_SEARCH_CONSOLE_CREDENTIALS och SEARCH_CONSOLE_SITE_URL, och lägg till tjänstekontot som användare på egendomen i Search Console.",

  // Dashboard - Conversion funnel and attribution
  Konverteringstratt: "Konverteringstratt",
  "Nådde formulärsida": "Nådde formulärsida",
  "Inskickade formulär": "Inskickade formulär",
  Köanmälningar: "Köanmälningar",
  "av föregående steg": "av föregående steg",
  Konverteringar: "Konverteringar",
  "Okänd källa": "Okänd källa",
  Källa: "Källa",
  Landningssida: "Landningssida",
  Kampanj: "Kampanj",

  // Dashboard - Applications
  Totalt: "Totalt",
  ID: "ID",
  Adress: "Adress",
  "Öppna vägbeskrivning": "Öppna vägbeskrivning",
  "Kopiera adress": "Kopiera adress",
  "Kopierat!": "Kopierat!",
  "Här finns vi!": "Här finns vi!",
  "Kunde inte ladda ansökningar från databasen. Försök igen senare.":
    "Kunde inte ladda ansökningar från databasen. Försök igen senare.",

  // Dashboard - Waiting List
  "Kunde inte ladda kölista från databasen. Försök igen senare.":
    "Kunde inte ladda kölista från databasen. Försök igen senare.",
  "Kölista uppdaterad": "Kölista uppdaterad",
  "Kunde inte uppdatera": "Kunde inte uppdatera",

  // Dashboard - Applications
  "Ansökan uppdaterad": "Ansökan uppdaterad",

  // Dashboard - Bookings
  Bokningar: "Bokningar",
  Lärare: "Lärare",
  "Välj lärare": "Välj lärare",
  "Namn på ny lärare": "Namn på ny lärare",
  "Tryck Enter för att skapa": "Tryck Enter för att skapa",
  Filter: "Filter",
  "Alla blocktyper": "Alla blocktyper",
  "Nytt block": "Nytt block",
  "Redigera veckoblock": "Redigera veckoblock",
  "Skapa veckoblock": "Skapa veckoblock",
  Veckodag: "Veckodag",
  Tid: "Tid",
  Start: "Start",
  Slut: "Slut",
  Typ: "Typ",
  "Välj typ...": "Välj typ...",
  Anteckningar: "Anteckningar",
  Spara: "Spara",
  "Sparar...": "Sparar...",
  "individual-lesson-adult": "Individuell lektion (vuxen)",
  "individual-lesson-child": "Individuell lektion (barn)",
  "group-lesson-children": "Grupplektion (barn)",
  Grupp: "Grupp",
  "individual-lesson-suzuki": "Individuell lektion (Suzuki)",
  unavailable: "Paus / otillgänglig",
  "Hantera lärare": "Hantera lärare",
  "Skapa lärare": "Skapa lärare",
  "Skapar...": "Skapar...",
  "Inga lärare": "Inga lärare",
  "Skapa, byt namn och aktivera/inaktivera lärare.":
    "Skapa, byt namn och aktivera/inaktivera lärare.",
  "Hantera blocktyper": "Hantera blocktyper",
  "Ändra för hela gruppen": "Ändra för hela gruppen",
  ApplyToGroup: "Ändra för hela gruppen",
  Blocktyper: "Blocktyper",
  "Importera från block": "Importera från block",
  "Skapa blocktyp": "Skapa blocktyp",
  "Används i databasen": "Används i databasen",
  Färg: "Färg",
  Ordning: "Ordning",
  Aktiv: "Aktiv",
  Inaktiv: "Inaktiv",
  Förhandsvisning: "Förhandsvisning",
  "Inga blocktyper": "Inga blocktyper",
  "Inget att importera": "Inget att importera",
  "Kunde inte spara": "Kunde inte spara",
  "Kunde inte skapa": "Kunde inte skapa",
  Sparat: "Sparat",
  "Importerade blocktyper": "Importerade blocktyper",
  Tillbaka: "Tillbaka",
  VisibleToClients: "Synlig för kunder",
  HiddenFromClients: "Dold",
  "Inga tider": "Inga tider",
  "Tillgängliga tider": "Tillgängliga tider",
  "Boka en ledig tid direkt i kalendern.":
    "Boka en ledig tid direkt i kalendern.",
  "Inga sparade platser": "Inga sparade platser",

  // Bookings - API errors
  "Ogiltig veckodag": "Ogiltig veckodag",
  "Ogiltigt tidsintervall": "Ogiltigt tidsintervall",
  "Blocket överlappar ett befintligt block":
    "Blocket överlappar ett befintligt block",
  "Block hittades inte": "Block hittades inte",
  "Start måste vara före slut": "Start måste vara före slut",
  "Regel hittades inte": "Regel hittades inte",
  "Tiden är utanför lärarens tidsram": "Tiden är utanför lärarens tidsram",
  "Bokningen överlappar en befintlig bokning":
    "Bokningen överlappar en befintlig bokning",
  "Återkommande bokningar måste inkludera COUNT eller UNTIL":
    "Återkommande bokningar måste inkludera COUNT eller UNTIL",
  "Återkommande serie för lång (max ~1 år)":
    "Återkommande serie för lång (max ~1 år)",
  "Återkommande bokning innehåller tider utanför lärarens tidsram":
    "Återkommande bokning innehåller tider utanför lärarens tidsram",
  "Återkommande bokning överlappar en befintlig bokning":
    "Återkommande bokning överlappar en befintlig bokning",
  "Serien hittades inte": "Serien hittades inte",
  "Tiden utanför lärarens tidsram": "Tiden utanför lärarens tidsram",
  "Tidsluckan är inte längre tillgänglig":
    "Tidsluckan är inte längre tillgänglig",
  "Lärare hittades inte": "Lärare hittades inte",

  // Dashboard - Metadata titles
  "Dashboard: Meddelanden": "Dashboard: Meddelanden",
  "Dashboard: Videohantering": "Dashboard: Videohantering",
  "Dashboard | Analys": "Dashboard | Analys",
  "Dashboard: Ansökningar": "Dashboard: Ansökningar",
  "Dashboard: Kölista": "Dashboard: Kölista",

  // Waiting List Settings
  LocationUpdated: "Plats uppdaterad",
  LocationAdded: "Plats tillagd",
  AreYouSure: "Är du säker?",
  LocationDeleted: "Plats borttagen",
  WaitingListSettings: "Inställningar för kölista",
  NewLocationName: "Namn på ny plats",
  AddLocation: "Lägg till plats",
  Status: "Status",
  PublicView: "Publik vy",
  OpenApplyNow: "Öppen / Ansök nu",
  WaitingList: "Kölista",
  MONDAY: "Måndag",
  TUESDAY: "Tisdag",
  WEDNESDAY: "Onsdag",
  THURSDAY: "Torsdag",
  FRIDAY: "Fredag",
  SATURDAY: "Lördag",
  SUNDAY: "Söndag",
  Boka: "Boka",
  "önskad tid": "Önskad tid",
  "Preliminär tid": "Preliminär tid",
  "Du ansöker om en tid inom detta intervall. Lektionslängden väljs nedan.":
    "Du ansöker om en tid inom detta intervall. Lektionslängden väljs nedan.",
  "Fiol- och cellolektioner i Stockholm":
    "Fiol- och cellolektioner i Stockholm",
  "Stockholm Stråkstudio är en musikskola för stråkinstrument i Vällingby, nära Bromma och Solna. Vi undervisar enligt Suzukimetoden och traditionell metod, för nybörjare såväl som avancerade elever.":
    "Stockholm Stråkstudio är en musikskola för stråkinstrument i Vällingby, nära Bromma och Solna. Vi undervisar enligt Suzukimetoden och traditionell metod, för nybörjare såväl som avancerade elever.",
  "Fiollektioner för barn & ungdom": "Fiollektioner för barn & ungdom",
  "från 3 år, med förälder som övningspartner. Undervisning vid Kristofferskolan (Brommaplan), i Vällingby och i Hagalund.":
    "från 3 år, med förälder som övningspartner. Undervisning vid Kristofferskolan (Brommaplan), i Vällingby och i Hagalund.",
  "Fiollektioner för vuxna": "Fiollektioner för vuxna",
  "nybörjare eller återupptagare — upplägget anpassas efter dig.":
    "nybörjare eller återupptagare — upplägget anpassas efter dig.",
  "Suzukifiol länk": "Suzukifiol",
  "modersmålsmetoden där barn lär sig spela som de lär sig tala, med föräldern som stöd.":
    "modersmålsmetoden där barn lär sig spela som de lär sig tala, med föräldern som stöd.",
  Cellolektioner: "Cellolektioner",
  "för barn och vuxna hos vår cellopedagog David Hurtado Gomez.":
    "för barn och vuxna hos vår cellopedagog David Hurtado Gomez.",
  "aktuella avgifter och terminsplanering.":
    "aktuella avgifter och terminsplanering.",
  "Undrar du något?": "Undrar du något?",
  eller: "eller",
} as const;

export default sv;
